import React from 'react'
import { Space } from 'antd'
import {
  Button,
  ButtonActionBar,
  Comments,
  DropdownMenu,
  FavouriteIcon,
  FavouriteSelect,
  References,
  TableSettingsModal,
  Typography,
} from 'modules/core/components'
import { useTranslation } from 'react-i18next'
import {
  DownloadOutlined,
  CommentOutlined,
  DollarOutlined,
  ControlOutlined,
} from '@ant-design/icons'
import { TABLES } from 'modules/core/constants'

const TopTableActions = ({
  setPeriodTableSettings,
  periodTableSettings,
  onClickDownload,
  onClickSaveFav,
  visibleFav,
  onClickSave,
  onClickCancelSaveFav,
  setFavouriteName,
  favouriteName,
  isLoading,
  hasFavourite = false,
  options = [],
  canSave,
  viewSelect = undefined,
  setViewSelect,
  alreadyExist = false,
  layoutLoading,
  setPrimary,
  onClickDeleteFav,
  showComments,
  hasComment,
  setHasComment,
  setViewComment,
  userDetail,
  settings,
  setDataComments,
  dataComments,
  onRefetchComments,
  loadingComments,
  onCommentCreate,
  isCommentSaving,
  removeNewComment,
  currencyData,
  onClickEditNameFav,
  onClckPreferences,
}) => {
  const { t } = useTranslation()

  const dowload = {
    spreadsheets: () => console.log('descarga spreadScheets'),
    file: onClickDownload,
  }

  return (
    <ButtonActionBar position="space-between">
      <References
        referencesItems={[
          {
            color: '',
            type: '123',
            title: t('LABEL_TYPE_VALUES_REFERENCE', {
              type: settings?.aggregatorName?.toLowerCase() || t('FIELD_DECIMALS').toLowerCase(),
            }),
          },
          {
            color: '#a73ba1',
            type: 'Ab',
            title: t('LABEL_RATIO'),
            description: t('REPORT_VALUES_RATIO'),
          },
          {
            color: '#e1effa',
            type: '⬤',
            title: t('LABEL_BUSINESS_RULES'),
            description: t('PLANNING_VALUES_FACTORS_APPLIED'),
          },
          ...(currencyData
            ? [
                {
                  type: <DollarOutlined />,
                  title: currencyData && currencyData.code,
                  description:
                    currencyData &&
                    t('REFERENCE_DESCRIPTION', {
                      currencyName: t(currencyData.name).toLowerCase(),
                    }),
                },
              ]
            : []),
        ]}
      />
      <Space direction="horizontal">
        {canSave && (
          <FavouriteIcon
            visible={visibleFav}
            favouriteName={favouriteName}
            setFavouriteName={setFavouriteName}
            onClickCancelSaveFav={onClickCancelSaveFav}
            onClickSave={onClickSave}
            loading={isLoading}
            alreadyExist={alreadyExist}
            onClickSaveFav={onClickSaveFav}
            options={options}
          />
        )}
        {hasFavourite && (
          <FavouriteSelect
            viewSelect={viewSelect}
            loading={layoutLoading}
            options={options}
            setPrimary={setPrimary}
            setViewSelect={setViewSelect}
            onClickDeleteFav={onClickDeleteFav}
            onClickEditNameFav={onClickEditNameFav}
          />
        )}
        {showComments && (
          <Comments
            hasComment={hasComment.table}
            onClick={(visible) => {
              setHasComment({ type: 'table', data: visible })
              !visible && removeNewComment()
              !visible && setViewComment(visible)
            }}
            comments={dataComments}
            setData={setDataComments}
            loading={loadingComments || isCommentSaving}
            onRefetchComments={onRefetchComments}
            onCommentCreate={onCommentCreate}
            onCleanHasComment={() => {
              setHasComment({ type: 'table', data: false })
              setViewComment(false)
            }}
          >
            <Typography.Icon
              style={{ cursor: 'pointer' }}
              title={t('LABEL_COMMENTS')}
              icon={CommentOutlined}
            />
          </Comments>
        )}
        <DropdownMenu
          title={t('ACTION_DOWNLOAD_TABLE')}
          placement="bottomRight"
          icon={<Typography.Icon icon={DownloadOutlined} />}
          menu={TABLES.OPTIONS_DOWNLOAD.map((formatType) => {
            return {
              title: formatType.name,
              key: formatType.id,
              onClick: dowload[formatType.id],
            }
          })}
        />
        <Button.Icon
          title="Preferencias"
          icon={<Typography.Icon icon={ControlOutlined} />}
          onClick={onClckPreferences}
        />
        {/* <TableSettingsModal onConfirm={setPeriodTableSettings} settings={periodTableSettings} /> */}
      </Space>
    </ButtonActionBar>
  )
}

export default TopTableActions
